// // Cores predefinidas para unidades administrativas
// const COLORS = [
//   '#1565c0 !important', // Blue 800
//   '#c62828 !important', // Red 800
//   '#2e7d32 !important', // Green 800
//   '#6a1b9a !important', // Purple 800
//   '#ef6c00 !important', // Orange 800
//   '#00838f !important', // Cyan 800
//   '#5d4037 !important', // Brown 800
//   '#283593 !important', // Indigo 800
//   '#827717 !important', // Lime 900
//   '#311b92 !important', // Deep Purple 900
//   '#bf360c !important', // Deep Orange 900
//   '#004d40 !important', // Teal 900
//   '#b71c1c !important', // Red 900
//   '#1a237e !important', // Indigo 900
//   '#1b5e20 !important', // Green 900
//   '#4a148c !important', // Purple 900
//   '#e65100 !important', // Orange 900
//   '#006064 !important', // Cyan 900
//   '#3e2723 !important', // Brown 900
//   '#263238 !important', // Blue Grey 900
//   '#f57f17 !important', // Amber 900
//   '#ff6f00 !important', // Orange 900
//   '#ff3d00 !important', // Deep Orange 900
//   '#ffab00 !important', // Yellow 900
//   '#ffd600 !important', // Yellow A700
//   '#ffea00 !important', // Yellow A100
//
// ];

/**
 * Calcula o hash FNV-1a para uma string
 * @param {string} str - A string a ser hashada
 * @returns {number} - O hash resultante
 */
function fnv1aHash(str) {
  let hash = 2166136261;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
  }
  return Math.abs(hash);
}

function hslToHex(h, s, l) {
  l /= 100;
  s /= 100;
  const k = n => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = n =>
    l - a * Math.max(-1, Math.min(Math.min(k(n) - 3, 9 - k(n)), 1));
  const toHex = x => {
    const hex = Math.round(x * 255).toString(16).padStart(2, '0');
    return hex;
  };
  return `#${toHex(f(0))}${toHex(f(8))}${toHex(f(4))}`;
}

/**
 * Gera um índice determinístico baseado no texto fornecido
 * @param {string} text - O texto para gerar o índice
 * @returns {number} - O índice gerado
 */
const getDeterministicIndex = (text) => {
  if (!text) return 0;
  const hash = fnv1aHash(text.toLowerCase());
  // O número primo 13 ajuda a espalhar ainda mais os índices
  return (hash * 13) % COLORS.length;
};

// Cache para armazenar cores já calculadas
const colorCache = new Map();

/**
 * Obtém uma cor baseada no texto fornecido
 * @param {string} text - O texto para gerar a cor
 * @returns {string} - A cor em formato hexadecimal
 */
export function getColorByText(text) {
  if (!text) return '#000000';

  if (colorCache.size > 10000) colorCache.clear();

  // Verifica se a cor já está em cache
  if (colorCache.has(text)) {
    return colorCache.get(text);
  }

  const hash = fnv1aHash(text.toLowerCase());

  // Abordagem em três grupos para maior variedade:
  // 1. Cores vibrantes (alta saturação, luminosidade média)
  // 2. Cores pastel (média saturação, alta luminosidade)
  // 3. Cores profundas (alta saturação, baixa luminosidade)

  const colorGroup = hash % 2;
  let hue = hash % 360; // Aproveitando todo o espectro de cores

  let sat, light;

  switch(colorGroup) {
    case 0: // Cores pastel
      sat = 40 + (hash % 20); // 40-60%
      light = 40 + (hash % 15); // 50-65%
      break;
    case 1: // Cores profundas
      sat = 70 + (hash % 25); // 70-95%
      light = 25 + (hash % 15); // 25-40%
      break;
  }

  // Pequeno ajuste adicional baseado nos caracteres do texto
  if (text.length > 0) {
    const charCode = text.charCodeAt(0);
    hue = (hue + (charCode % 30) - 15) % 360; // Ajuste sutil no matiz
  }

  let color = hslToHex(hue, sat, light) + ' !important';

  // Armazena a cor no cache
  colorCache.set(text, color);

  return color;
}

export default getColorByText;

// Função para limpar o cache se necessário
export function clearColorCache() {
  colorCache.clear();
}



// WEBPACK FOOTER //
// ./src/assets/utils/colorByText.js